import { useTable } from 'react-table';

/*
The useTable instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useTable.md#instance-properties
*/
const useStandardTable = ({ columns, data }) => {
  const tableInstance = useTable({
    columns,
    data,
  });
  return { columnsLength: columns.length, ...tableInstance };
};

export default useStandardTable;
